window.o_global = window.o_global || {};

o_global.device = o_global.device || {};

/**
 * Module to retrieve information about the orientation of the screen.
 * Additional it offers an API to register callback functions, which will be executed, when the orientation is changed.
 */
o_global.device.orientation = (function() {
    "use strict";

    // Definitions for the orientation types.
    var _orientation = {
            "portrait": window.matchMedia("(orientation: portrait)"),
            "landscape": window.matchMedia("(orientation: landscape)")
        },
        _currentOrientation = "unknown",
        _registeredCallbacks = [];

    /**
     * Register a listener on the matchMedia queries.
     * This listener executes all functions in _registeredCallbacks array.
     *
     * @private
     */
    function _initializeOrientationListeners() {
        var listenerWrapper = {},
            i,
            max;

        listenerWrapper.trigger = function(mql) {
            // Because the listener is registered on both orientations,
            // an orientation change will trigger both listeners.
            // But the registered function should only execute once.
            // With mql.matches only the listener for the active orientation will be executed.
            if (mql.matches) {
                // Set the correct value in the variable _currentOrientation.
                _setOrientation();

                // All registered functions get called on the orientation change.
                for (i = 0, max = _registeredCallbacks.length; i < max; i++) {
                    _registeredCallbacks[i](_currentOrientation);
                }
            }
        };

        // In LHAS-860 we modified the matchMedia Polyfill.
        // Due to that, the orientation cannot be listened with the "orientationchange" event,
        // because the fix from LHAS-860 only work with matchMedia.
        _orientation.portrait.addListener(listenerWrapper.trigger);
        _orientation.landscape.addListener(listenerWrapper.trigger);
    }

    /**
     * Is the current screen in portrait orientation?
     *
     * @return {Boolean} A flag if the current screen is in portrait orientation
     * @private
     */
    function _isPortrait() {
        return _orientation.portrait.matches;
    }

    /**
     * Is the current screen in landscape orientation?
     *
     * @return {Boolean} A flag if the current screen is in landscape orientation
     * @private
     */
    function _isLandscape() {
        return _orientation.landscape.matches;
    }

    /**
     * Update the _currentOrientation variable with current value.
     *
     * @private
     */
    function _setOrientation() {
        if (_isPortrait()) {
            _currentOrientation = "portrait";
        } else if (_isLandscape()) {
            _currentOrientation = "landscape";
        } else {
            _currentOrientation = "unknown";
        }
    }

    /**
     * Returns the name of the active screen orientation as String.
     * Possible values: unknown, portrait, landscape
     *
     * @return {String} The name of the active screen orientation [unknown, portrait, landscape]
     */
    function getCurrentOrientation() {
        return _currentOrientation;
    }

    /**
     * Registers a listener for orientation changes.
     *
     * @param {Function} callback   Callback-function. When invoked it is passed the name of the current orientation as String and the matchMedia-Object of the orientation that has become active.
     */
    function registerChangeListener(callback) {
        _registeredCallbacks.push(callback);
    }

    /**
     * Initialize the orientation and
     * register the orientation change listener on the matchMedia queries.
     */
    _setOrientation();
    _initializeOrientationListeners();

    /**
     * Return public methods.
     */
    return {
        "getCurrentOrientation": getCurrentOrientation,
        "registerChangeListener": registerChangeListener
    };
})();
